import React from "react";

const AppML_Google_Cloud_SQL = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Google Cloud SQL</h1>
      <p>This is the AppML Google Cloud SQL page content.</p>
    </div>
  );
};

export default AppML_Google_Cloud_SQL;
